<template>
  <div>
    <div>
      <template :key="index" v-for="(item, index) in levels">
        <div class="standard-field-wrapper py-2">
          <label for="item.name">{{item.label}}</label>
          <div class="standard-input-wrapper">
            <div class="standard-input-container">
              <siloSelect
                :level="item.admin_level.toString()"
                :fieldName="item.name"
                :countryCode="countryIso"
                :initialValue="initialOptions[index]"
                :partOf="partOfValues[index]"
                :partOfRequired="item.part_of ? true : false"
                :val="location[index]"
                v-on:on-value-change="onNewValue">
              </siloSelect>
            </div>
            <div style="display: none;" :id="'vue-hidden-location-' + item.name + '_name'">{{ partName(item.name) }}</div>
          </div>
        </div>
      </template>
    </div>
    <div style="display: none;" :id="`vue-hidden-location-name`"> {{ fullName }} </div>
  </div>
</template>

<script>
  import siloCalloutService from '@services/siloCalloutService'
  import siloSelect from '../components/siloSelect.vue'
  const NAME = 'silo-location-selector'

  export default {
    name: NAME,
    components: {
      siloSelect,
    },
    data () {
      return {
        countryIso: this.countryCode,
        selectedItem: {},
        admin1: '',
        admin1Label: '',
        admin2: '',
        admin2Label: '',
        admin3: '',
        admin3Label: '',
        admin4: '',
        admin4Label: '',
        initialOptions: [{},{},{},{},],
        error: false,
      }
    },
    computed: {
      partOfValues() {
        let result = []
        let vi = this
        this.levels.forEach((lvl, ind) => {
          if (lvl.part_of && lvl.part_of != ''){
            if (Array.isArray(lvl.part_of)) {
              result.push(vi.$data[lvl.part_of[0]] != '' ? vi.$data[lvl.part_of[0]] : vi.$data[lvl.part_of[1]] )
            } else
            {
              result.push(vi.$data[lvl.part_of])
            }
          } else {
            result.push('')
          }
        })
        return result
      },
      finalLevel() {
        return this.levels.slice(-1).name
      },
      callOutOpts() {
        let opts = {
          level: this.levels.length,
          country_code: this.countryIso,

        }
        switch (this.location.type) {
          case 'point':
            opts.point = this.location.value
            break
          case 'names':
            opts.search = this.location.value.slice(-1)[0]
            break
          case 'id':
            opts.part_of = this.location.value
        }
        console.log(opts)
        return opts
      },
      fullName() {
        let fn = ''
        if (this.levels){
          for (const lv of this.levels) {
            let lb = this[`${lv.name}Label`]
            if (lb && lb.replace(/\s/g,'').length > 0) {
              console.log(lb)
              fn += `${fn.length > 0 ? '-' : ''}${lb}`
            }
          }
        }
        return fn
      },
    },
    created () {
      console.log(this.$props)
      if (this.location && this.location.value) {
        console.log('I have a location')
        this.getInitialOptions()
      }

      if (this.countryData) {
        this.countryIso = this.countryData.iso3_code
      }
    },
    mounted() {
    },
    methods: {
      onNewValue(v) {
        console.log(v)
        this[v.field] = v.value
        this[v.field + 'Label'] = v.label
        this.updateHiddenFields(v)
        this.$emit("on-value-change", v)

      },
      updateHiddenFields (v) {
        console.log('updating hidden elements')
        console.log(this.hiddenElements)
        if (this.hiddenElements && this.hiddenElements[v.field]) {
          let heObj = this.hiddenElements[v.field]
          console.log(heObj)
          console.log(Object.keys(heObj))
          for (const key of Object.keys(heObj)) {
            let newVal = ''
            switch (key) {
              case 'id':
                newVal = v.value
                break
              case 'partName':
                newVal = v.label
                break
              case 'fullName':
                newVal = this.fullName
                break
            }
            console.log(heObj[key])
            console.log(newVal)
              let el = document.getElementById(heObj[key])
              console.log(el)
              if (el) {
                el.value = newVal
                var event = new Event('change');
                el.dispatchEvent(event);
                console.log(el)
              }
          }
        }
      },
      partName(fld) {
        return this[fld + "Label"] || null
      },
      processResult(rep) {
        let result = rep.data.features[0]
        console.log(rep)
        let opts = []
        this.levels.forEach((lvl, ind) => {
          let opt = ''
          switch (lvl.name) {
            case 'admin1':
              opt = {
                admin1_id: result.admin1_id,
                admin1_name: result.admin1_name,
              }
              //this.admin1 = opt
              break
            case 'admin2':
              opt = {
                admin1_id: result.admin1_id,
                admin1_name: result.admin1_name,
                admin2_id: result.admin2_id,
                admin2_name: result.admin2_name,
              }
              break
            case 'admin3':
              opt = {
                admin1_id: result.admin1_id,
                admin1_name: result.admin1_name,
                admin2_id: result.admin2_id,
                admin2_name: result.admin2_name,
                admin3_id: result.admin3_id,
                admin3_name: result.admin3_name,
              }
              break
            case 'admin4':
              opt = result
              break
          }
          opts.push(opt)
            //this.admin1 = ladmin1
        })
        this.initialOptions = opts
      },
      handleError(err){
        console.log(err)
        this.error = 'Unexpected error while updating record!'
      },
      getInitialOptions(){
        console.log('getting initial options')
        siloCalloutService.callOut(this.callOutOpts, this.processResult, this.handleError)
      },
    },
    props: {
      levels: {
        type: Array,
        required: true,
      },
      countryCode: {
        type: String,
        required: true,
      },
      location: {
        type: Object,
        required: false,
      },
      hiddenElements: {
        type: Object,
        required: false,
      },
    },
  }
</script>

<style>
  .bold {
    font-weight: bold;
  }

  .pad {
    margin: 5px;
  }
  .tab-base {
    @apply bg-white border-l border-r border-t border-gray-300 inline-block rounded-t-lg pb-2 px-4 text-blue-600 font-semibold
  }
  .tab-active {
    @apply border-t-2 border-r-2
  }
  .tab-not-active {
    @apply hover:text-blue-500
  }
  .tab-page {
    @apply bg-white rounded-r-lg rounded-b-lg p-4 border-l border-r border-b
  }
</style>
